import React from 'react';
import PropTypes from 'prop-types';

import styles from './Card.css';

const Card = (props) => {
    const styleToUse = props.styles || styles;
    return (
        <div className={props.addOverflow ? 'card scroll-card' : 'card'}>
            {props.children}
            <style jsx>{styleToUse}</style>
        </div>
    );
};

Card.defaultProps = {
    /**
     * If no children are passed, render empty div
     */
    addOverflow: false,
    children: <div />
};

Card.propTypes = {
    /**
     * Child component should contain a node
     */
    addOverflow: PropTypes.bool,
    children: PropTypes.node
};

export default Card;
